import { CleaveOptions } from 'cleave.js/options';

/* Documentation for cleave.js options -> https://github.com/nosir/cleave.js/blob/master/doc/options.md */

export type TextFieldType = {
  type: 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url';
};

export type TextFieldPreset = TextFieldType & {
  options: CleaveOptions;
};

export type TextFieldPresets = {
  currency: TextFieldPreset;
  text: TextFieldType;
  numeric: TextFieldPreset;
  numericWholePositive: TextFieldPreset;
  positiveInteger: TextFieldPreset;
  password: TextFieldType;
  email: TextFieldType;
  date: TextFieldPreset;
  number: TextFieldPreset;
  creditCard: TextFieldPreset;
  tel: TextFieldPreset;
  private: TextFieldType;
  googleAddressLine1: TextFieldType;
  googleAddressCity: TextFieldType;
  googleAddressProvince: TextFieldType;
  googleAddressPostalCode: TextFieldType;
  googleAddressCountry: TextFieldType;
  fullName: TextFieldType;
  numericKeyboard: TextFieldType;
};

const presets: TextFieldPresets = {
  currency: {
    type: 'text',
    options: {
      numeral: true,
      numeralDecimalScale: 2,
      numeralPositiveOnly: true,
    },
  },
  text: {
    type: 'text',
  },
  number: {
    type: 'text',
    options: {
      numeral: true,
      numeralThousandsGroupStyle: 'none',
      stripLeadingZeroes: false,
    },
  },
  numeric: {
    type: 'text',
    options: {
      numeral: true,
    },
  },
  numericWholePositive: {
    type: 'text',
    options: {
      numeral: true,
      numeralDecimalScale: 0,
      numeralPositiveOnly: true,
    },
  },
  positiveInteger: {
    type: 'text',
    options: {
      numeral: true,
      numeralThousandsGroupStyle: 'none',
      numeralDecimalScale: 0,
      stripLeadingZeroes: false,
      numeralPositiveOnly: true,
    },
  },
  password: {
    type: 'text',
  },
  email: {
    type: 'email',
  },
  tel: {
    type: 'tel',
    options: {
      delimiter: '-',
      numericOnly: true,
      blocks: [3, 3, 4],
    },
  },
  date: {
    type: 'text',
    options: {
      date: true,
      delimiter: '-',
      datePattern: ['Y', 'm', 'd'],
    },
  },
  creditCard: {
    type: 'text',
    options: {
      creditCard: true,
    },
  },
  private: {
    type: 'text',
  },
  googleAddressLine1: {
    type: 'text',
  },
  googleAddressCity: {
    type: 'text',
  },
  googleAddressProvince: {
    type: 'text',
  },
  googleAddressPostalCode: {
    type: 'text',
  },
  googleAddressCountry: {
    type: 'text',
  },
  fullName: {
    type: 'text',
  },
  numericKeyboard: {
    type: 'numeric',
  },
};

export default presets;
